import { CheckboxContainer, HiddenInput, Label } from "./styled";

interface CheckboxProps {
  name: string;
  label: string;
  checked: boolean;
  onChange: (name: string) => void;
  readOnly?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  checked,
  onChange,
  readOnly,
}: CheckboxProps) => (
  <CheckboxContainer className="checkbox-container" readOnly={readOnly}>
    <label htmlFor={name}>
      {readOnly ? (
        <HiddenInput
          type="checkbox"
          data-testid={`checkbox-readonly-${name}`}
          onChange={() => onChange(name)}
          checked={checked}
        />
      ) : (
        <HiddenInput
          id={name}
          type="checkbox"
          data-testid={`checkbox-${name}`}
          onChange={() => onChange(name)}
          checked={checked}
        />
      )}
      <svg className="check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path fill="none" d="M4.1 15.2l8.1 9.2 16.7-16.8" />
      </svg>
      <Label>{label}</Label>
    </label>
  </CheckboxContainer>
);

export default Checkbox;
